module.exports = __webpack_public_path__ + "img/printspooler.0d490fcb.jpg";